import { Spinner } from '../ui/spinner';

export function OverlaySpinner() {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-background/90 z-[9999] text-center">
      <div>
        <Spinner className="text-primary size-16 mb-8 mx-auto" />
      </div>
    </div>
  );
}
